<script>
export default {
  data() {
    return {
      title: "Report Users",
      text: "Users",
      text1: "Report Users",
      Name: "Report Users List",
    };
  },
};
</script>
<template>
  <admin-header></admin-header>
  <admin-sidebar></admin-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <user-breadcrumb :title="title" :text="text" :text1="text1" />
      <!-- Page Header -->

      <!-- User List -->
      <div class="card">
        <user-top :Name="Name"></user-top>

        <!-- Block-user List -->
        <report-table></report-table>
      </div>
      <!-- /Block-user List -->
    </div>
  </div>
  <!-- /Page Wrapper -->
  <!-- Report Reason -->
  <div class="modal fade" id="report_reason">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Report Reason</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>
            <i class="ti ti-info-circle me-2"></i>Directing hate against a protected
            category (e.g., race, religion, gender, orientation, disability)
          </p>
          <div class="close-btn">
            <a href="#" class="btn btn-primary close-btn" data-bs-dismiss="modal"
              >Close</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Report Reason -->
</template>
